import {Injectable, Type} from '@angular/core';
import {TextMessageComponent} from './message-type/text-message/text-message.component';
import {SelectionListMessageComponent} from './message-type/selection-list-message/selection-list-message.component';
import {TypingIndicatorComponent} from './message-type/typing-indicator/typing-indicator.component';
import {ImageMessageComponent} from './message-type/image-message/image-message.component';
import {ResponseDtoType} from '../dto/ResponseDtoType';
import {FilesMessageComponent} from './message-type/files-message/files-message.component';
import {MultiSelectionListMessageComponent} from './message-type/multiselection-list-message/multi-selection-list-message.component';
import {LinksMessageComponent} from './message-type/links-message/links-message.component';
import {ThinkingIndicatorComponent} from './message-type/thinking-indicator/thinking-indicator.component';
import {DelayedRenderedMessageComponent} from './message-type/delayed-rendered-message-component';
import {ImmediatelyRenderedMessageComponent} from './message-type/immediately-rendered-message-component';

@Injectable()
export class BotatoChatMessageResolverService {

    public messageMapping = new Map<string, Type<ImmediatelyRenderedMessageComponent | DelayedRenderedMessageComponent>>();

    constructor() {
        this.messageMapping.set(TextMessageComponent.TYPE, TextMessageComponent);
        this.messageMapping.set(ImageMessageComponent.TYPE, ImageMessageComponent);
        this.messageMapping.set(SelectionListMessageComponent.TYPE, SelectionListMessageComponent);
        this.messageMapping.set(TypingIndicatorComponent.TYPE, TypingIndicatorComponent);
        this.messageMapping.set(FilesMessageComponent.TYPE, FilesMessageComponent);
        this.messageMapping.set(MultiSelectionListMessageComponent.TYPE, MultiSelectionListMessageComponent);
        this.messageMapping.set(LinksMessageComponent.TYPE, LinksMessageComponent);
        this.messageMapping.set(ThinkingIndicatorComponent.TYPE, ThinkingIndicatorComponent);
    }

    public resolve(messageType: ResponseDtoType): Type<ImmediatelyRenderedMessageComponent | DelayedRenderedMessageComponent> {
        const mesageTypeComponent = this.messageMapping.get(messageType);
        if (mesageTypeComponent === undefined) {
            throw new Error(`No MessageComponent available for type '${messageType}'. IMPORTANT: This could happen because there are multiple imports of BotatoBotengineBrowser, which influences the instanceof in MessageRouter.sendSingleItem().`);
        }
        return mesageTypeComponent;
    }
}


